import InputUtils from 'helpers/inputUtils';
import React from 'react';

const inputUtils = new InputUtils();

const VehiclesSchedule = ({ vehicles }) => {
  return (
    <div className="max-w-6xl mx-auto p-6 bg-white">
      <h2 className="text-2xl font-bold text-red-500 text-center mb-2">
        Vehicle Schedule
      </h2>

      <p className="text-sm mb-4">
        It is hereby noted and agreed that only the vehicle(s)
        specified in the schedule will be covered:
      </p>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-[#666666] text-white font-bold text-center">
              <th className="px-4 py-2">Power Unit #</th>
              <th className="px-4 py-2">Year</th>
              <th className="px-4 py-2">Make/Model</th>
              <th className="px-4 py-2">VIN</th>
              <th className="px-4 py-2">Body Type</th>
              <th className="px-4 py-2">Class</th>
            </tr>
          </thead>
          <tbody>
            {vehicles?.length === 0 && (
              <tr>
                <td colSpan="6" className="text-center pt-2">
                  No vehicles found
                </td>
              </tr>
            )}
            {vehicles?.map((vehicle, index) => (
              <tr
                key={index}
                className={
                  index % 2 === 0
                    ? 'bg-white text-sm'
                    : 'bg-gray-50 text-sm'
                }
              >
                <td className="px-4 py-2 font-bold">{index + 1}</td>
                <td className="px-4 py-2 font-bold">
                  {vehicle.year}
                </td>
                <td className="px-4 py-2">
                  {vehicle.make} {vehicle.model}
                </td>
                <td className="px-4 py-2 font-mono text-sm">
                  {vehicle.vin}
                </td>
                <td className="px-4 py-2">
                  {inputUtils.capitalizeFirstLetter(
                    vehicle.bodyTypeKey
                  )}
                </td>
                <td className="px-4 py-2">{vehicle.classKey}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VehiclesSchedule;
